import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from "@jti/store";
import { ConditionalView } from "../../components/conditional-view/ConditionalView";
import Loader from "../../components/loader/Loader";
const GeneralLayout = ({ children, isInEditor }) => {
    const isLoaded = useSelector((state) => state.loyaltyCore.isLoaded);
    return (_jsxs(_Fragment, { children: [_jsx(ConditionalView, { condition: !isLoaded && !isInEditor, children: _jsx(Loader, {}) }), _jsx(ConditionalView, { condition: isLoaded || isInEditor, children: children })] }));
};
export default GeneralLayout;
//# sourceMappingURL=GeneralLayout.js.map